/* jshint esversion: 8 */
define([
    "lit-element/lit-element.bundled",
    "components/cloudCenterElement",
    "validation/inlineComponentValidation",
    "components/inlinePopover",
    "util"
], function(
    Lit,
    CloudCenterElement,
    InlineComponentValidation,
    InlinePopover,
    Util
) {

    class ManagementCloudAccount extends CloudCenterElement {

        constructor () {
            super();
        }

        cceInitialize () {
            super.cceInitialize();
            Util.consoleLogTrace('ManagementCloudAccount`, `cceInitialize invoked');
            // Default values
            this.elementlabel = "";
            this.poptext = "";
            this.dduxenabled = false;
            this.mcainputid = "";
            this.mcainputplaceholder = "";
            this.mcainputvalue = "";
        }

        // Reactive Properties -- updates rendering when values change
        static get properties () {
            return {
                elementlabel: {type: String},
                poptext: {type: String},
                dduxenabled: {type: Boolean},
                mcainputid: {type: String},
                mcainputplaceholder: {type: String},
                mcainputvalue: {type: String}
            };
        }

        // Render element template
        render () {
            return Lit.html`
                <div class="labelContainer">
                    <label for="${'cloudAccountFieldset' + this.timestamp}">${this.elementlabel}</label>
                </div>
                <div class="section2InputValidationContainer" id="${'cloudAccountFieldset' + this.timestamp}">
                    <input type="text" id="${this.mcainputid}" name="${this.mcainputid}" placeholder="${this.mcainputplaceholder}" value="${this.mcainputvalue}" />
                    <inline-validation elementid="${this.mcainputid}" />
                </div>
                <inline-popover poptext="${this.poptext}" />
            `;
        }
    }
    // Register custom element '<license-manager-simple elementid="myelementid" />'
    customElements.define('management-cloud-account', ManagementCloudAccount);

    return ManagementCloudAccount;
});
